import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { getAppeals } from '../../../actions/adminActions'
import { Row, Col } from 'reactstrap'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import Loading from '../../loading'
import Stats from './_Stats'
import { Link } from 'react-router-dom'
import { FaEdit, FaPlusCircle } from 'react-icons/fa'
// import Moment from 'react-moment'
import PendingAdjudicator from './_PendingAdjudicator'
import PendingAppellant from './_PendingAppellant'

var moment = require('moment')
const FilterableTable = require('react-filterable-table')

class AdminDashBoard extends Component {
  constructor (props) {
    super(props)

    this.state = {
      showInactive: false
    }

    this.toggleInactive = this.toggleInactive.bind(this)
  }

  toggleInactive () {
    this.setState({
      showInactive: !this.state.showInactive
    })
  }

  componentWillMount () {
    this.props.getAppeals()
  }
  render () {
    const renderEdit = (props) => {
      /*
       * This props object looks like this:
       * {
       *   value:  (value of the field in the data. In this case, it's the person's age.),
       *   record: (the data record for the whole row, in this case it'd be: { name: "Steve", age: 27, job: "Sandwich Eater" }),
       *   field:  (the same field object that this render function was passed into. We'll have access to any props on it, including that 'someRandomProp' one we put on there. Those can be functions, too, so we can add custom onClick handlers to our return value)
       * }
       */

      return (
        <Link className='btn-primary btn btn-sm' to={`/admin/appeal/${props.value}`}><FaEdit /> View</Link>
      )
    }
    // const renderSubmitDate = (props) => {
    //   const expired = moment(props.value).add(1, 'days').isBefore(moment(new Date(), 'day'))
    //   if (expired) {
    //     return <div className='expired-text'><Moment ago to={moment(props.value).endOf('day')}>{moment()}</Moment> ago</div>
    //   } else {
    //     return <Moment ago to={moment(props.value).endOf('day')}>{moment()}</Moment>
    //   }
    // }
    // const renderSubmittedDate = (props) => {
    //   if (!props.value) {
    //     return <p className='expired-text'>Not submitted</p>
    //   } else {
    //     return moment(props.value).format('DD/MM/YY')
    //   }
    // }
    // Fields to show in the table, and what object properties in the data they bind to
    const fields = [
      { name: 'date', displayName: 'Issue Date', inputFilterable: true, sortable: true, render: (props) => { return moment(props.value).format('DD/MM/YY') } },
      { name: 'pcn', displayName: 'PCN', inputFilterable: true, exactFilterable: true, sortable: true },
      { name: 'reg', displayName: 'Registration', inputFilterable: true, exactFilterable: true, sortable: true, render: (props) => (<span className='registration-ui'>{props.value}</span>) },
      // { name: 'submitby', displayName: 'Submit in', inputFilterable: true, exactFilterable: true, sortable: true, render: renderSubmitDate },
      // { name: 'submittedDate', displayName: 'Submitted Date', inputFilterable: true, exactFilterable: true, sortable: true, render: renderSubmittedDate },
      { name: 'lname', displayName: 'Last name', inputFilterable: true, exactFilterable: true, sortable: true },
      { name: 'status', displayName: 'Status', inputFilterable: true, exactFilterable: true, sortable: true, tdClassName: 'td-uppercase' },
      { name: 'appealID', displayName: '', inputFilterable: false, exactFilterable: false, sortable: false, render: renderEdit, tdClassName: 'text-right' }

    ]

    return (
      <div>
        {(this.props.admin.appeals && this.props.admin.auth)
          ? <div>
            <Row>
              <Col><h1>Dashboard</h1></Col>
            </Row>
            <Row>
              <Col sm='12' md='4'>
                <Link className='btn btn-secondary btn-block mb-5' to={`/admin/create`}><FaPlusCircle /> Create an appeal manually</Link>
                <hr />
                <Stats />
                <hr />
                <PendingAdjudicator />
                <hr />
                <PendingAppellant />

              </Col>

              <Col sm='12' md='8'>
                <Row className='content pb-5'>
                  <Col>
                    {this.props.admin.loading
                      ? <div className='table-loading-spinner' />
                      : null }
                    <FilterableTable
                      namespace='Appeals'
                      initialSort='date'
                      stickySorting='true'
                      data={(this.props.admin.appeals !== null) ? this.props.admin.appeals : []}
                      fields={fields}
                      noRecordsMessage='There are no appeals to display'
                      noFilteredRecordsMessage='No match'
                      topPagerVisible={false}
                      tableClassName='table table-bordered small'
                    />
                    {/* <Button color='secondary' onClick={this.toggleInactive}>Show inactive</Button> */}
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          : <Loading />}

      </div>
    )
  }
};

AdminDashBoard.propTypes = {
  getAppeals: PropTypes.func,
  admin: PropTypes.object,
  appeals: PropTypes.object
}

const mapStateToProps = ({ admin }) => ({
  admin
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getAppeals
    },
    dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminDashBoard))



// WEBPACK FOOTER //
// ./src/containers/admin/AdminDashBoard/AdminDashBoard.jsx